<template>
    <div class="add-product-packaging">
        <v-layout row justify-center>
            <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-btn slot="activator" depressed flat class="caption font-weight-regular" style="color: #757575; text-transform: none !important;"
                    :ripple="false">
                    <template v-if="this.width && this.length && this.height">
                        {{ this.width }} cm, {{ this.length }} cm, {{ this.height }} cm
                    </template>
                    <template v-else>Set Size</template>
                    <v-icon>chevron_right</v-icon>
                </v-btn>
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click="dialog = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title class="subheading">Packaging Size</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn dark flat @click="save">Save</v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-alert :value="true" color="grey lighten-4" style="color: black;" icon="new_releases">
                        Please use packaging size, not product size. Inaccurate size may result in failed pickup or
                        additional shipping fee.
                    </v-alert>
                    <v-content class="package-content pt-4">
                        <v-form style="background-color: #fff;">
                            <v-divider></v-divider>
                            <v-layout row>
                                <v-flex xs6 order-lg2>
                                    <v-card-text>Width (in cm)</v-card-text>
                                </v-flex>
                                <v-flex xs6>
                                    <v-text-field label="Subject" placeholder="Set Width" suffix hide-details single-line full-width v-model="width"></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-divider></v-divider>
                            <v-layout row>
                                <v-flex xs6 order-lg2>
                                    <v-card-text>Length (in cm)</v-card-text>
                                </v-flex>
                                <v-flex xs6>
                                    <v-text-field label="Subject" placeholder="Set Length" suffix hide-details single-line full-width v-model="length"></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-divider></v-divider>
                            <v-layout row>
                                <v-flex xs6 order-lg2>
                                    <v-card-text>Height (in cm)</v-card-text>
                                </v-flex>
                                <v-flex xs6>
                                    <v-text-field label="Subject" placeholder="Set Height" suffix hide-details single-line full-width v-model="height"></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-divider></v-divider>
                        </v-form>
                    </v-content>
                </v-card>
            </v-dialog>
        </v-layout>
    </div>
</template>
<script>
    export default {
        name : 'AddProductPackaging',
        props :{
            eventName : {
                type : String,
                default : 'setPackagingSize'
            }
        },
        data() {
            return {
                dialog  : false,
                width   : '',
                length  : '',
                height  : '',
            }
        },
        methods : {
            save(){
                let data = {};

                data.width  = this.width;
                data.length = this.length;
                data.height = this.height;

                //validation
                if (data.width <= 0 || data.length <= 0 || data.height <= 0){
                    this.toaster('Please input a valid value.', 201);
                    return;
                }

                EventBus.$emit(this.eventName, data);
                this.dialog = false;
            }
        },
        mounted(){
            EventBus.$on('setProductPackagingSizeData', (data)=>{
                this.width  = data.width  ;
                this.length = data.length ;
                this.height = data.height ;
            });
        }
    }
</script>

<style lang="scss">
@import "../../scss/app";
   

        .package-content {
            caption {
                font-size: 5px;
            }

            .theme--light.v-input:not(.v-input--is-disabled) input,
            .theme--light.v-input:not(.v-input--is-disabled) textarea {
                text-align: right !important;
                font-size: 13px;
                color: #757575;
                font-weight: 500;
            }


        }
    
</style>